"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Colors_1 = require("components/styled/Colors");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const candles = require(`../../img/candles-2x.png`);
const candlesMobile = require(`../../img/candles-4x.png`);
const leaf = require(`../../img/leaf-2x.png`);
const leafMobile = require(`../../img/leaf-4x.png`);
const ContainerBase = styled_components_1.default.div `
  overflow: hidden;
`;
exports.HeroContainer = styled_components_1.default(ContainerBase) `
  background-color: ${Colors_1.WHITE};
`;
exports.NetworkContainer = styled_components_1.default(ContainerBase) `
  background-color: ${Colors_1.KARL};
`;
exports.OrderbookContainer = styled_components_1.default(ContainerBase) `
  background-color: ${Colors_1.SPACE};
  background-image: url(${candlesMobile});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    background-image: url(${candles});
  }

  ${ScreenSizes_1.DESKTOP} {
    background-size: 1440px;
  }
`;
exports.ConsensusContainer = styled_components_1.default(ContainerBase) `
  background: ${Colors_1.REGENT};
  background-image: url(${leafMobile});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 330px;

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    background-image: url(${leaf});
    background-position: left 5% top;
    background-size: 40%;
  }

  ${ScreenSizes_1.DESKTOP} {
    background-size: 35%;
  }
`;
exports.ActionContainer = styled_components_1.default(ContainerBase) `
  background-color: ${Colors_1.WHITE};
`;
exports.FooterContainer = styled_components_1.default(ContainerBase) `
  background-color: ${Colors_1.KARL};
`;
const ContentBase = styled_components_1.default.div `
  margin: 0 20px;
  max-width: 1128px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin: 0 52px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    margin: 0 112px;
  }

  ${ScreenSizes_1.DESKTOP} {
    margin: 0 auto;
  }
`;
exports.NavContent = styled_components_1.default(ContentBase) `
  align-items: center;
  display: flex;
  padding: 30px 0;
`;
exports.HeroContent = styled_components_1.default(ContentBase) `
  padding: 20px 0 80px 0;
  position: relative;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    padding: 130px 0;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    padding: 150px 0;
  }

  ${ScreenSizes_1.DESKTOP} {
    padding: 180px 0;
  }
`;
exports.SectionContent = styled_components_1.default(ContentBase) `
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-height: 40vh;
  padding: 80px 0;
  position: relative;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    padding: 110px 0;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    min-height: 60vh;
    padding: 136px 0;
  }

  ${ScreenSizes_1.DESKTOP} {
    min-height: 80vh;
    padding: 200px 0;
  }
`;
exports.FooterContent = styled_components_1.default(ContentBase) `
  padding: 40px 0;
  position: relative;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    padding: 100px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Containers.ts